var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.875 15.6309C46.875 13.9027 45.475 12.5059 43.75 12.5059C21.3125 12.5059 3.125 30.6934 3.125 53.1309C3.125 75.5527 21.3281 93.7559 43.75 93.7559C58.2625 93.7559 71.675 86.0121 78.9312 73.4434C79.7937 71.9465 79.2844 70.0371 77.7875 69.1746L46.875 51.3246V15.6309ZM40.625 18.8965V53.1309C40.625 54.2465 41.2219 55.2777 42.1875 55.8371L71.8344 72.9527C65.4344 82.0246 54.9813 87.5059 43.75 87.5059C24.7781 87.5059 9.375 72.1027 9.375 53.1309C9.375 35.1996 23.1063 20.4746 40.625 18.8965Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.25 6.25586C54.525 6.25586 53.125 7.65273 53.125 9.38086V46.8809C53.125 47.9965 53.7219 49.0277 54.6875 49.5871L87.1625 68.3371C88.6594 69.1996 90.5687 68.6871 91.4312 67.1934C94.9969 61.0184 96.875 54.0121 96.875 46.8809C96.875 24.4434 78.6875 6.25586 56.25 6.25586ZM59.375 12.6465C76.8937 14.2246 90.625 28.9496 90.625 46.8809C90.625 51.8684 89.5406 56.784 87.4594 61.2902L59.375 45.0746V12.6465Z",
    fill: "var(--icon-accent, #E56910)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.bbc9aa2ba0cee199bd6bf9cbfafb4e4a.svg";
export { ForwardRef as ReactComponent };